module.exports = __webpack_public_path__ + "img/mo-fm.4f3918dd.png";